// Module to hold functions to assist working with Material UI DropDownMenus
import MenuItem from '@material-ui/core/MenuItem';
import React from 'react';

/**
 * Always show atleast 9 more than the current quanity.
 * @param {number} currentQuantity current number of items in the cart.
 */
const buildQuantityList = (currentQuantity = 1) => {
	const quantityValues = [];
	for (let i = 1; i <= 10 + (currentQuantity - 1); i += 1) {
		quantityValues.push(
			<MenuItem value={i} key={i} style={{ height: '12px' }}>
				{i}
			</MenuItem>,
		);
	}

	return quantityValues;
};

export default buildQuantityList;
